
















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { RelatorioLogPrecificacaoModel } from "@/models/administracao/log-precificacao/RelatorioLogPrecificacaoModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { LogPrecificacaoModel } from "@/models/administracao/log-precificacao/LogPrecificacaoModel";
import moment from "moment";
import { tipoServicoVeicularList } from "@/models/commons/TipoServicoModel";
import DetalhesLogPrecificacao from "@/views/private/administracao/log-precificacao/DetalhesLogPrecificacao.vue";
import { statusServicos } from "@/models/commons/StatusServicosVeicularModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
    DetalhesLogPrecificacao
  },
})
export default class LogPrecificacao extends Vue {

  LogPrecificacaoModel = [] as LogPrecificacaoModel[];
  detalhesLogPrecificacaoModel = {} as LogPrecificacaoModel;

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  loading: boolean = false;

  detalhesLogPrecificacaoModal = false;

  cabecalho = [
    {
      text: "Cód. Serviço",
      value: "servico.numeroServico",
      align: "center",
      divider: true,
    },
    {
      text: "Serviço",
      value: "servico.tipoServico",
      width: "15%",
      align: "center",
      divider: true,
    },
    {
      text: "Cliente",
      value: "servico.cliente.nome",
      align: "center",
      divider: true,
    },
    {
      text: "Data Ocorrência",
      value: "dataCriacao",
      align: "center",
      divider: true,
    },
    {
      text: "Status",
      value: "servico.status",
      width: "20%",
      align: "center",
      divider: true,
    },
    {
      text: "Detalhes",
      value: "actions",
      sortable: false,
      width: "10%",
      divider: true,
    },
  ];

  relatorio: RelatorioLogPrecificacaoModel = {
    numeroServico: undefined,
    cpfCnpjCliente: undefined,
    tipoServico: { name: undefined, descricao: "Todos" },
    servicoContratado: undefined,
    dataPrecificacao: undefined
  };

  tiposServicoVeicular = tipoServicoVeicularList;
  statusServicoVeicular = statusServicos;
  tiposServicoContratado = [
  { valor: undefined, descricao: "Todos" },
    { valor: true, descricao: "Sim" },
    { valor: false, descricao: "Não" },
  ];

  descricaoStatusCliente(status: string) {
    let descricao = "";

    statusServicos.filter(statusStatic => {
      statusStatic.valor!!.forEach(valor => {
        if (status == valor) {
          descricao = statusStatic?.descricao || '';
        }
      });
    });
    return descricao;
  }

  exibirDetalhes(id: number) {
    this.detalhesLogPrecificacaoModel = this.LogPrecificacaoModel.find((tipo) => tipo.id == id)!;
    this.detalhesLogPrecificacaoModal = true;
  }


  public fnCloseDialog(): void {
    this.detalhesLogPrecificacaoModel = {};
    this.detalhesLogPrecificacaoModal = false
  }

  gerarRelatorio() {
      this.loading = true;
      ServicosAssistenciaService.gerarRelatorioLogPrecificacao(this.relatorio)
        .then((res) => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute("download", "relatorio_logs_precificacao.pdf");

          document.body.appendChild(fileLink);

          fileLink.click();

          this.loading = false;
        })
        .catch((err) => {
          this.openDialog(false, 'Erro', err.message);
          this.loading = false;
        });

      this.limparformulario();
  }

  gerarRelatorioExcel() {
      this.loading = true;
      ServicosAssistenciaService.gerarRelatorioLogPrecificacaoXls(this.relatorio)
        .then((res) => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute("download", "relatorio_logs_precificacao.xls");

          document.body.appendChild(fileLink);

          fileLink.click();

          this.loading = false;
        })
        .catch((err) => {
          this.openDialog(false, 'Erro', err.message);
          this.loading = false;
        });

      this.limparformulario();
    }

    filtrarContaReceber() {

      if (this.relatorio.numeroServico == "") {
        this.relatorio.numeroServico = undefined;
      }

      if (this.relatorio.cpfCnpjCliente == "") {
        this.relatorio.cpfCnpjCliente = undefined;
      }

      ServicosAssistenciaService.filtrarLogPrecificacao(this.relatorio).then( 
        (res) => {
          this.LogPrecificacaoModel = res.data;
        }
      );
    }

  limparformulario() {
    this.relatorio = {
      numeroServico: undefined,
      cpfCnpjCliente: undefined,
      tipoServico: undefined,
      servicoContratado: undefined,
      dataPrecificacao: undefined
    };
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.successDialog ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.successDialog ? 'success.png' : 'error.png';
  }

}
